module.exports = __webpack_public_path__ + "static/media/failure.23d36cd8.png";